import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ForecastHeader = () => {
    const [isOpen, setIsOpen] = useState(false)
    const navigate = useNavigate()

    const modalHandleChange = async () => {
        const { Modal } = await import("bootstrap");
        const modal = new Modal(document.getElementById("m1"))
        if (!isOpen) {
            modal.show()
            let newIsOpen = !isOpen
            setIsOpen(newIsOpen)
        }
        else {
            modal.hide()
            let newIsOpen = !isOpen
            setIsOpen(newIsOpen)
        }
    }

    return (
        <div className='container block-container-home'>
            <div className='m-3'>
                <br />
                <h3 className='text-white' style={{ float: "left" }}>22 มกราคม พ.ศ. 2563</h3>
                <h3 className='text-white' style={{ float: "right" }} onClick={() => navigate("/")}>X</h3>
                <div style={{ clear: "both" }}></div> {/* Combined the clear styles */}
                <div className='text-white'><i className="fa-solid fa-location-dot"></i>&nbsp;&nbsp;บางนา, กรุงเทพ, ประเทศไทย</div>
                <br />
                <h5 className='text-white'>พยากรณ์อากาศ(เพื่อรักษาผิวหนัง)&nbsp;<i
                    className="fa-solid fa-circle-info text-white"
                    onClick={() => {
                        modalHandleChange()
                    }}
                ></i></h5>
                <div className='m-3'></div>
                <img
                    alt="calendar"
                    src="/assets/images/forecastdata.png"
                    style={{
                        width: "100%"
                    }}
                />
                <div
                    className="modal fade"
                    id="m1"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex={-1}
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content bg-primary text-white">
                            <div className="modal-header">
                                ความเข้มของแสงอาทิตย์
                                <button
                                    type="button"
                                    className=" text-white btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => {
                                        modalHandleChange()
                                    }}
                                    style={{
                                        color: "white"
                                    }}
                                />
                            </div>
                            <div className="modal-body">
                                <img
                                    src="/assets/images/forecast-info.png"
                                    alt="data"
                                    style={{
                                        width: "100%"

                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForecastHeader;
